module.exports = __webpack_public_path__ + "static/media/onboarding2.28483778.png";